// node modules
import { RefinementListFilter } from 'searchkit';

/**
 * A refinement list that records the reader operated it before it runs the search. Both handlers
 * call `performSearch` themselves, and the history write encodes the entry state at that moment,
 * so the mark has to be made first.
 */
class TouchTrackingRefinementListFilter extends RefinementListFilter {
  /**
   * @override
   * @param {String} key
   */
  toggleFilter(key) {
    this.searchkit.markFilterTouched(this.props.id);
    super.toggleFilter(key);
  }

  /**
   * @override
   * @param {Array.<String>} keys
   */
  setFilters(keys) {
    this.searchkit.markFilterTouched(this.props.id);
    super.setFilters(keys);
  }
}

export default TouchTrackingRefinementListFilter;
